import Icon from "./Icon";

const values = [
  {
    number: "01",
    title: "Know the person",
    text: "Good care starts with listening—to a resident's story, routines, choices and the people important to them.",
  },
  {
    number: "02",
    title: "Plan together",
    text: "Residents, families and professionals contribute to support that reflects current needs and preferences.",
  },
  {
    number: "03",
    title: "Keep adapting",
    text: "The team reviews support as needs change, while protecting dignity, independence and familiar routines.",
  },
];

const About = () => (
  <section className="section section--warm" id="about">
    <div className="container">
      <div className="intro-grid">
        <div className="section-heading">
          <p className="eyebrow">About Ascot Lodge</p>
          <h2>A smaller home with time for what matters</h2>
        </div>
        <div className="intro-grid__copy">
          <p className="lead-copy">
            Set in an adapted period house in Southport, Ascot Lodge supports
            up to 18 older people with nursing and personal care.
          </p>
          <p>
            The home is designed to feel calm and familiar. Residents have
            private rooms, shared spaces for conversation and meals, and access
            to an enclosed garden. Families are encouraged to talk openly with
            the team and stay closely involved.
          </p>
          <a className="text-link" href="#care">
            Explore our approach to care
            <Icon name="arrow" size={19} />
          </a>
        </div>
      </div>

      <div className="values-panel">
        <div className="values-panel__intro">
          <Icon name="heart" size={30} />
          <p className="eyebrow">Resident-centred care</p>
          <h3>Support shaped around the individual</h3>
          <p>
            A thoughtful move into care should begin with a conversation, not
            a checklist. This simple approach guides how support is planned.
          </p>
        </div>
        <ol className="values-list">
          {values.map(({ number, title, text }) => (
            <li key={number}>
              <span aria-hidden="true">{number}</span>
              <div>
                <h4>{title}</h4>
                <p>{text}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);

export default About;
